import axios from '@/utils/http';

export default conversationId => {
  let url =
    '/user/details' +
    (conversationId ? `?conversationId=${conversationId}` : '');
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
